<div class="history-feed">
  <div class="day-group" *ngFor="let group of dayGroups">
    <div class="day-separator">
      <span class="day-label">{{ group.dayLabel }}</span>
      <span class="separator-line"></span>
    </div>

    <ol class="timeline-list">
      <li class="timeline-entry" *ngFor="let entry of group.entries; let last = last" [class.last]="last">
        <span class="guide-line" aria-hidden="true" *ngIf="!last"></span>

        <div class="icon-dot" [class.ai-dot]="entry.isAi">
          <span class="material-icons entry-icon" [class.ai-icon]="entry.isAi">{{ entry.isAi ? 'auto_awesome' : entry.icon }}</span>
        </div>

        <div class="entry-content">
          <div class="entry-action">{{ entry.action }}</div>
          <div class="entry-detail" *ngIf="entry.detail">{{ entry.detail }}</div>
          <div class="entry-meta">
            <ng-container *ngIf="entry.isAi && !entry.actor">Auto · {{ entry.time }}</ng-container>
            <ng-container *ngIf="!entry.isAi && entry.actor">{{ entry.actor }} · {{ entry.time }}</ng-container>
            <ng-container *ngIf="!entry.isAi && !entry.actor">{{ entry.time }}</ng-container>
          </div>
        </div>
      </li>
    </ol>
  </div>

  <div class="no-history" *ngIf="!dayGroups.length">
    {{ 'request_v2.history.no_entries' | translate }}
  </div>
</div>
